import { useEffect, useState } from "react";

/** "MM:SS" / "HH:MM:SS" since startIso while active; "00:00" otherwise. Ticks once a second. */
export function useElapsed(startIso, active) {
  const [txt, setTxt] = useState("00:00");
  useEffect(() => {
    if (!active || !startIso) { setTxt("00:00"); return undefined; }
    const tick = () => {
      const s = Math.max(0, Math.floor((Date.now() - new Date(startIso).getTime()) / 1000));
      const h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
      setTxt(`${h ? `${String(h).padStart(2, "0")}:` : ""}${String(m).padStart(2, "0")}:${String(sec).padStart(2, "0")}`);
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [startIso, active]);
  return txt;
}

/** Local wall clock, e.g. "7:42:05 PM", ticking once a second. */
export function useClock() {
  const [txt, setTxt] = useState(() => new Date().toLocaleTimeString([], { hour: "numeric", minute: "2-digit", second: "2-digit" }));
  useEffect(() => {
    const id = setInterval(() => setTxt(new Date().toLocaleTimeString([], { hour: "numeric", minute: "2-digit", second: "2-digit" })), 1000);
    return () => clearInterval(id);
  }, []);
  return txt;
}
